import { lazyLoad } from 'utils/loadable';

export const TagsManagementPageLoadable = lazyLoad(
  () => import('./TagsManagementPage'),
  module => module.TagsManagementPage,
);
